import React from "react";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Card from "@material-ui/core/Card";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import FormControl from "@material-ui/core/FormControl";
import attach from "mson-react/lib/attach";
import { strings } from "../../lib/strings";
import cardStyle from "../../lib/cardStyle";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import AgentHomeScreenReminder from "../UI/molecules/AgentHomeScreenReminder";

const selectStyle = {
  marginRight: "22px",
  marginTop: "11px",
};
const dobStyle = {
  width: "50px",
};
class SearchFieldsField extends React.PureComponent {
  // classes = useStyles();
  processor = null;
  constructor(props) {
    super(props);
    this.processor = props.processor;
    this.state = {
      country: null,
      selectedDate: null,
      dd: null,
      mm: null,
      yyyy: null,
      passportNo: "",
    };
  }
  handlePassPortChange = (passportno) => {
    this.setState({ passportNo: passportno.target.value });
  };
  handleCountryChange = (country) => {
    this.setState({ country: country.target.value });
  };
  handleDateChange = (date) => {
    this.setState({ selectedDate: date });
  };
  handleYYYYChange = (yyyy) => {
    this.setState({ yyyy: yyyy.target.value });
  };
  handleMMChange = (mm) => {
    this.setState({ mm: mm.target.value });
  };
  handleDDChange = (dd) => {
    this.setState({ dd: dd.target.value });
  };

  render() {
    const { selectedDate, passportNo } = this.state;

    return (
      <Grid container direction="row" spacing={10} justifyContent="center">
        <Grid item key="blank" xs={12} sm={8} md={8} lg={4}>
          <Paper></Paper>
        </Grid>
        <Grid item key="scan" xs={12} sm={8} md={8} lg={4}>
          <Card
            style={{
              height: "500px",
              width: "500px",
              margin: "auto",
              ...cardStyle,
            }}
          >
            <CardContent>
              <h3>Search for customer:</h3>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  required
                  margin="normal"
                  id="date-picker-dialog"
                  format="MM/dd/yyyy"
                  value={selectedDate}
                  label={strings.todaysDateLabel}
                  onChange={this.handleDateChange}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
              <div>
                <h4>Date of birth</h4>
                <FormControl required style={{ ...selectStyle, width: "65px" }}>
                  <Autocomplete
                    id="dd-select"
                    options={strings.days}
                    getOptionLabel={(option) => option.label}
                    style={{ width: "65px", paddingRight: "11px" }}
                    renderInput={(params) => (
                      <TextField
                        required
                        {...params}
                        style={{ ...dobStyle, width: "65px" }}
                        label={"DD"}
                      />
                    )}
                  />
                </FormControl>
                <FormControl
                  required
                  style={{ ...selectStyle, width: "120px" }}
                >
                  <Autocomplete
                    id="mm-select"
                    options={strings.months}
                    getOptionLabel={(option) => option.label}
                    style={{ width: "120px" }}
                    renderInput={(params) => (
                      <TextField
                        style={{ width: "120px" }}
                        required
                        {...params}
                        label={"MM"}
                      />
                    )}
                  />
                </FormControl>
                <FormControl
                  required
                  style={{ ...selectStyle, width: "100px" }}
                >
                  <Autocomplete
                    id="yyyy-select"
                    options={strings.years}
                    getOptionLabel={(option) => option.label}
                    style={{ width: "100px" }}
                    renderInput={(params) => (
                      <TextField
                        style={{ width: "100px" }}
                        required
                        {...params}
                        label={"YYYY"}
                      />
                    )}
                  />
                </FormControl>
              </div>
              <div>
                <TextField
                  required
                  id="passport-number"
                  label="Passport No."
                  value={passportNo}
                  onChange={this.handlePassPortChange}
                />
              </div>
              <div>
                <FormControl
                  required
                  style={selectStyle}
                  id="country-select-control"
                >
                  <Autocomplete
                    id="country-select"
                    options={strings.countries}
                    getOptionLabel={(option) => option.label}
                    style={{ width: "200px" }}
                    renderInput={(params) => (
                      <TextField {...params} label="Country of Issuance" />
                    )}
                  />
                </FormControl>
              </div>
              <div style={{ textAlign: "right" }}>
                <Button type={"Submit"}>Submit</Button>
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item key="reminder" xs={12} sm={8} md={8} lg={4}>
          <AgentHomeScreenReminder />
        </Grid>
      </Grid>
    );
  }
}
const returnValue = attach(["processor", "ready"])(SearchFieldsField);

export default returnValue;
